// @flow
import get from 'lodash/get';

class InternalError extends Error {
  constructor(response: any) {
    super();
    const status = get(response, 'status');
    const detail = get(response, 'errors[0].detail');
    const title = get(response, 'errors[0].title');

    const message = detail || title;
    const err = Error(message);

    // $FlowFixMe
    this.status = status;
    this.name = 'InternalError';
    // $FlowFixMe
    this.status = 500;
    this.stack = err.stack;
  }
}

export default InternalError;



// WEBPACK FOOTER //
// ./src/utils/errors/internal-error.js